module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADzSURBVHgB7ZWLDYIwEIavhQHYQEbgsYCO4AZu4Ai6gSOoE+gIOAChG8gGdgGCVx4Gqm3BREJM/4T0mvuufxOuLYDVCJHuJI7jS1mWXAkT4qdpuhrIesiu3xJhGF5BI8yfgiDwRRxF0dHEtjGV3B/wA1GYQNZkfiZudyJ6W9eamF9g7+dN7JvYVywn23PwSYyx/BuWSEVLHJSFdS1jY9neP6GUbnHIVZ/jOAdc3Kt2R8jewO7adV3JnaN5AgrhVbHBQZhwNLlnWWZi683DBLImMzcRp1gLU1p1VsN6A9hKvRYuiuKsuyrwuU2wxXkT30ws/J2eNX9ezr+VQgMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/one.png
// module id = wu48
// module chunks = 1